import { isBetweenDates } from '@scouts/helpers'

import config from '@/config'
import {
    QUARTERS,
    TAX_RETURN_STATUS_CANCELLED,
    TAX_RETURN_STATUS_COMPLETED_NOT_FILED,
    TAX_RETURN_STATUS_FILED,
    TAX_RETURN_STATUS_FILING_NOT_REQUIRED,
} from '@/constants'
import { getCurrentYear, getDate, getIsDateExceeded, subtractDays } from '@/helpers/dates'
import { pluck } from '@/helpers/fp'

const { enabledTaxReturnTaxYears, taxReturnStartDay, taxReturnStartMonth } = config

export const getEnabledTaxReturnTaxYears = () => [
    ...new Set([...enabledTaxReturnTaxYears, ...(getIsTaxReturnSeasonStarted() ? [getCurrentTaxReturnTaxYear()] : [])]),
]

export const getCurrentTaxReturnTaxYear = (year = getCurrentYear()) =>
    getIsTaxReturnMarketingCampaignSeasonStarted({ year }) ? year - 1 : year - 2

const getAnnualTaxReturnMarketingCampaignSeasonStartDate = (year = getCurrentYear()) => `${year}-03-01`
const getAnnualTaxReturnSeasonStartDate = (year = getCurrentYear()) =>
    `${year}-${taxReturnStartMonth}-${taxReturnStartDay}`
const getIsTaxReturnMarketingCampaignSeasonStarted = ({ year = getCurrentYear(), date = getDate() } = {}) =>
    // @TODO:
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getIsDateExceeded(date, getAnnualTaxReturnMarketingCampaignSeasonStartDate(year) as any, { inclusive: true })
export const getIsTaxReturnSeasonStarted = ({ year = getCurrentYear(), date = getDate() } = {}) =>
    // @TODO:
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getIsDateExceeded(date, getAnnualTaxReturnSeasonStartDate(year) as any, { inclusive: true })

export const getIsNextTaxReturnSeasonAboutToStart = (year = getCurrentYear()) =>
    getIsTaxReturnMarketingCampaignSeasonStarted({ year }) && !getIsTaxReturnSeasonStarted({ year })

export const getIsCurrentTaxReturnTaxYear = (taxYear = getCurrentTaxReturnTaxYear()) =>
    Number(taxYear) === getCurrentTaxReturnTaxYear()

// we should display not created tax return if current date is past april
// so self employed have already filed Q1, then we can notice them about tax return
export const getShouldDisplayNotCreatedTaxReturnToSubscriber = (date: Date) =>
    isBetweenDates(date, `${date.getFullYear()}-05-01`, `${date.getFullYear()}-06-30`)

export const getNaturalYear = (taxYear = getCurrentTaxReturnTaxYear()) => Number(taxYear) + 1

export const getDeadlineYear = getNaturalYear
export const getAnnualTaxReturnFilingDeadline = (taxYear = getCurrentTaxReturnTaxYear()) =>
    `${getDeadlineYear(taxYear)}-06-30`

/**
 * Usually 5 days earlier than filing's deadline, but sometimes a bit later, depending on the calendar.
 * Needs to be adjusted on a per-year basis.
 */
export const getAnnualTaxReturnDirectDebitDeadline = (taxYear = getCurrentTaxReturnTaxYear()) =>
    // @TODO:
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    subtractDays(3)(getAnnualTaxReturnFilingDeadline(taxYear) as any)

export const getIsAnnualTaxReturnFilingDeadlineExceeded = ({
    taxYear = getCurrentTaxReturnTaxYear(),
    date = getDate(),
    // @TODO:
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
} = {}) => getIsDateExceeded(date, getAnnualTaxReturnFilingDeadline(taxYear) as any)
export const getIsAnnualTaxReturnDirectDebitDeadlineExceeded = ({
    taxYear = getCurrentTaxReturnTaxYear(),
    date = getDate(),
} = {}) => getIsDateExceeded(date, getAnnualTaxReturnDirectDebitDeadline(taxYear))

export const getHasSelfEmployment = pluck('hasSelfEmployment')

const getQuarters = (taxYear: number) =>
    [...QUARTERS]
        .sort()
        .reverse()
        .map((quarter) => ({
            taxYear,
            quarter,
        }))

export const getTaxYearsWithQuarters = () => {
    const { enabledQuarterlyTaxReturnTaxYears } = config
    const taxYearsWithQuarters = [...enabledQuarterlyTaxReturnTaxYears]
        .sort()
        .reverse()
        .flatMap((year) => getQuarters(year))

    return taxYearsWithQuarters
}

export const getIsTaxReturnStatusFinal = (status: string) =>
    [
        TAX_RETURN_STATUS_COMPLETED_NOT_FILED,
        TAX_RETURN_STATUS_FILED,
        TAX_RETURN_STATUS_FILING_NOT_REQUIRED,
        TAX_RETURN_STATUS_CANCELLED,
    ].includes(status)

export const getEmploymentSectionTitle = ({ hasSubscription }: { hasSubscription: boolean }) =>
    hasSubscription ? 'Empleo por cuenta ajena' : 'Trabajo'
